// Header actions for Models (BOM) slide only: + New model, Bulk import, Refresh.
// Variants / Slots / Part uses own their own import/export chrome.
// AI Assistant lives in ManufacturingModelsWorkspaceChrome (next to the title).
import { ghostBtnClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function ManufacturingModelsRecipeToolsActions({
  onModelsSlide,
  isCreate,
  gateEnabled,
  gateLoading,
  listBusy,
  detailBusy,
  onNewModel,
  onBulkImport,
  onStartFromBrief,
  onRefresh,
  onOpenBomAudit,
}: {
  onModelsSlide: boolean;
  isCreate: boolean;
  gateEnabled: boolean;
  gateLoading: boolean;
  listBusy: boolean;
  detailBusy: boolean;
  onNewModel: () => void;
  onBulkImport: () => void;
  onStartFromBrief: () => void;
  onRefresh: () => void;
  /** Jump to Production → BOM Audit (desk / plant-manager roles). */
  onOpenBomAudit?: () => void;
}) {
  const showNewModel = onModelsSlide && isCreate;
  const showBulkImport = onModelsSlide && isCreate && gateEnabled;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {showNewModel ? (
        <button
          type="button"
          className={mfgPrimaryBtnClass}
          onClick={onNewModel}
          disabled={!gateEnabled || gateLoading}
        >
          + New model
        </button>
      ) : null}
      {showBulkImport ? (
        <button
          type="button"
          className={ghostBtnClass}
          onClick={onStartFromBrief}
          disabled={!gateEnabled || gateLoading}
        >
          Start from brief
        </button>
      ) : null}
      {showBulkImport ? (
        <button
          type="button"
          className={ghostBtnClass}
          onClick={onBulkImport}
          disabled={!gateEnabled || gateLoading}
        >
          Bulk import
        </button>
      ) : null}
      {onOpenBomAudit ? (
        <button
          type="button"
          className={ghostBtnClass}
          onClick={onOpenBomAudit}
          disabled={!gateEnabled || gateLoading}
          title="Open Production → BOM Audit"
        >
          BOM Audit
        </button>
      ) : null}
      <button
        type="button"
        className={ghostBtnClass}
        onClick={onRefresh}
        disabled={gateLoading || listBusy || detailBusy}
      >
        {listBusy ? "Refreshing…" : "Refresh"}
      </button>
    </div>
  );
}
